import ViewFile from "./ViewFile"
import { getFileIcon, s4 } from 'tyan/public'
import { getDownloadUrl } from "../Form/Block/renderFiles/fileRealServe"

const innerTypes = ['image-o', 'audio-o', 'video']
/**
 * viewFile
 * @param {*} id 
 * @param {*} mode
 * 		nullish or false: 新窗口
 * 		1: 弹出窗口，暂未处理
 * @param {*} pdfComments：从流转日志进入时为true，使用ViewFile查看pdf
 */
const viewFile = ({file, mode, pdfComments}) => {
	const icon = getFileIcon(file.FileExt)

	if (icon === 'pdf-o' && pdfComments) {
		const id = s4()
		sessionStorage[`viewFile${id}`] = JSON.stringify(file)
		window.open(
			`/#/ViewFile/${id}`,
			'_blank',
			// 'popup'
			`popup,width=${screen.availWidth},height=${screen.availHeight}`
		)
	} else if (['image-o', 'pdf-o'].includes(icon) /* icon === 'image-o' */ || !Tyan.wsFrontEditor.connected) {
		window.open(
			getDownloadUrl(file),
			'_blank',
			// `popup,width=${screen.availWidth},height=${screen.availHeight},toolbar=no,location=no,status=no,menubar=no`
		)
	} else {
		Tyan.pubForm.showFrontEditor({ file, openOnly: true })
	}
}

export { viewFile }
export default ViewFile